// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ItalicOutlinedSvg from "@ant-design/icons-svg/es/asn/ItalicOutlined";
import AntdIcon from '../components/AntdIcon';

var ItalicOutlined = function ItalicOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ItalicOutlinedSvg
  }));
};

ItalicOutlined.displayName = 'ItalicOutlined';
export default React.forwardRef(ItalicOutlined);